import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { oneDark } from 'react-syntax-highlighter/dist/esm/styles/prism';

// Tarefa 8.2 (FR-057): visualizacao com syntax highlighting para a categoria
// "Codigo" da spec (specs/skills/spec.md) - sem toggle Previa/Codigo, um
// arquivo de codigo nao tem uma forma "renderizada" distinta do proprio
// codigo. Tambem usado pelo modo "Codigo" do .html (FR-056), que reaproveita
// este mesmo componente com extension="html".
export const CODE_EXTENSIONS = new Set([
    'py', 'js', 'ts', 'java', 'sql', 'go', 'rb', 'php', 'c', 'cpp', 'cs', 'css', 'sh',
]);

// Mapeamento extensao -> identificador de linguagem reconhecido pelo Prism
// (react-syntax-highlighter). Extensoes fora deste mapa caem em 'text' (sem
// highlight nenhum, mas ainda dentro do mesmo componente/estilo visual).
const LANGUAGE_BY_EXTENSION = {
    py: 'python',
    js: 'javascript',
    ts: 'typescript',
    java: 'java',
    sql: 'sql',
    go: 'go',
    rb: 'ruby',
    php: 'php',
    c: 'c',
    cpp: 'cpp',
    cs: 'csharp',
    css: 'css',
    sh: 'bash',
    html: 'markup',
};

export function languageForExtension(extension) {
    return LANGUAGE_BY_EXTENSION[extension] || 'text';
}

// Mesma paleta escura ja usada pelo bloco de codigo do markdown renderizado
// (.skill-detail-content-markdown pre/code, #1e1e2e/#f1f1f4,
// SkillsManagerModal.css) - sobrescreve o tema Prism padrao (oneDark) so no
// necessario pra bater visualmente com o resto da tela, sem duplicar a
// paleta inteira.
const CUSTOM_STYLE = {
    margin: 0,
    padding: '14px 16px',
    borderRadius: 10,
    background: '#1e1e2e',
    fontSize: 13,
    lineHeight: 1.5,
    overflowX: 'auto',
};

const CODE_TAG_PROPS = {
    style: {
        fontFamily: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace",
    },
};

// `testId` vira um wrapper <div> (em vez de confiar em prop pass-through do
// SyntaxHighlighter pro <pre> interno, nao documentado/garantido pela lib).
export default function CodeHighlight({ code, extension, testId }) {
    return (
        <div className="skill-detail-content-code" data-testid={testId}>
            <SyntaxHighlighter language={languageForExtension(extension)} style={oneDark} customStyle={CUSTOM_STYLE} codeTagProps={CODE_TAG_PROPS}>
                {code || ''}
            </SyntaxHighlighter>
        </div>
    );
}
